import React from 'react';
import { Page } from '../Page';
export function DividerSideEffects() {
  return <Page hideFooter variant="dark" data-id="element-650" data-mp="1mh1i5s5g6tbt">
      <div className="flex flex-col h-full justify-center items-center text-center" data-id="element-651" data-mp="1mg05xkcp40si">
        <p className="text-[10px] font-bold text-lightteal uppercase tracking-[0.25em] mb-4" data-id="element-652" data-mp="1rg4orh12t7lw">
          Part Five
        </p>
        <h1 className="text-5xl font-serif text-white leading-tight mb-6" data-id="element-653" data-mp="1vhg6l0dpkojj">
          Side Effects & Challenges
        </h1>
        <div className="w-16 h-0.5 bg-tealslate" data-id="element-654" data-mp="ypmenw1xq5yz" />
      </div>
    </Page>;
}